import { render, staticRenderFns } from "./BenchRelation.vue?vue&type=template&id=796c730a&scoped=true&"
import script from "./BenchRelation.vue?vue&type=script&lang=js&"
export * from "./BenchRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796c730a",
  null
  
)

export default component.exports